import React, { useContext, useState, useRef, useEffect } from 'react';
import { map, each, remove } from 'lodash';
import { FocusBaseContext, MarkupContext } from '../../../contexts';

const RegionsMapper = () => {
  const {
    markupTool, selectedRegionId, currentSummary, heatmap
  } = useContext(FocusBaseContext);
  const {
    handleAreaClick, createMode, selectedSquare, deselectComments, loading, changeConceptStage,
    setRegionModal, clearNewRegion
  } = useContext(MarkupContext);
  const [ sector, setSector ] = useState(null);

  const findClipRegions = () => ([ ...(markupTool.clipRegions || []) ]);
  const [ clipRegions, setClipRegions ] = useState(findClipRegions);
  useEffect(() => {
    setClipRegions(findClipRegions());
  }, [ currentSummary, heatmap, selectedRegionId ]);
  const findScaledRegions = () => {
    each(clipRegions, (region) => {
      markupTool.mergeScaledRegion(region);
    });

    return [ ...clipRegions ];
  };
  const [ scaledRegions, setScaledRegions ] = useState(findScaledRegions);
  useEffect(() => {
    setScaledRegions(findScaledRegions());
  }, [ clipRegions ]);


  const readOnly = !createMode;
  const regionsRef = useRef(null);
  const start = useRef(null);

  const regionsBox = () => (regionsRef.current.getBoundingClientRect());

  const getCoords = (event) => {
    const box = regionsBox();
    const bodyData = document.getElementsByTagName('body')[0].getBoundingClientRect();
    return {
      x: event.pageX - box.left,
      y: event.pageY - box.top + bodyData.top
    };
  };

  const applySelectionCoords = (x, y) => {
    const startBox = start.current;
    const sectorBox = {};
    if (startBox.x > x) {
      sectorBox.left = x;
      sectorBox.width = startBox.x - x;
    } else {
      sectorBox.left = startBox.x;
      sectorBox.width = x - startBox.x;
    }

    if (startBox.y > y) {
      sectorBox.top = y;
      sectorBox.height = startBox.y - y;
    } else {
      sectorBox.top = startBox.y;
      sectorBox.height = y - startBox.y;
    }

    const box = regionsBox();

    sectorBox.image_width = box.width;
    sectorBox.image_height = box.height;

    setSector(sectorBox);
    return sectorBox;
  };

  const startSelection = (event) => {
    if (readOnly) {
      handleAreaClick(event);
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const cc = getCoords(event);
    start.current = { x: cc.x, y: cc.y };
    applySelectionCoords(cc.x, cc.y);
  };

  const changeSelection = (event) => {
    if (start.current) {
      event.preventDefault();
      event.stopPropagation();

      const cc = getCoords(event);
      applySelectionCoords(cc.x, cc.y);
    }
  };

  const finishSelection = (event) => {
    if (start.current) {
      event.preventDefault();
      event.stopPropagation();

      const cc = getCoords(event);
      const sectorBox = applySelectionCoords(cc.x, cc.y);

      if (sectorBox.width > 3 && sectorBox.height > 3) {
        clipRegions.push(sectorBox);
        setClipRegions([ ...clipRegions ]);
        setRegionModal({ data: [ sectorBox ] });
      }
      setSector(null);
      start.current = null;
    }
  };

  const loadingInProgress = loading || !!changeConceptStage;

  useEffect(() => {
    if (clipRegions.length && clearNewRegion) {
      remove(clipRegions, clipRegions[clipRegions.length - 1]);
      setClipRegions([ ...clipRegions ]);
    }
  }, [ clearNewRegion ]);

  return (
    <>
      {
        !loadingInProgress &&
        <div
          ref={ regionsRef }
          className="regions"
          onMouseDown={ startSelection }
          onMouseMove={ changeSelection }
          onMouseUp={ finishSelection }
        >
          {
            !!sector &&
            <div
              className="selection"
              style={
                { left: sector.left, top: sector.top, width: sector.width, height: sector.height }
              }
            />
          }

          {
            map(scaledRegions, (sr, index) => (
              <div
                key={ `reg-${index}` }
                className="region"
                style={ { left: sr.left, top: sr.top, width: sr.width, height: sr.height } }
              />
            ))
          }
        </div>
      }
      {
        !loadingInProgress && readOnly && markupTool.hasSelectedComments() &&
        <div className="regions">
          <span
            className="icon-link close-region"
            style={ { left: selectedSquare.x, top: selectedSquare.y } }
            onClick={ deselectComments }
          >
            <svg className="icon-link_icon icon -i-remove-round">
              <use xlinkHref="#svg_i-remove-round" />
            </svg>
          </span>
        </div>
      }
    </>
  );
};

export default RegionsMapper;
